import styles from "./NavBar.module.css";
import React, {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom"; // Import Link from react-router-dom
import {FaMoon, FaSun} from "react-icons/fa";
import {IoLogOutSharp} from "react-icons/io5";
import {
    setLayout,
    setTheme,
    useGlobalDispatch,
    useGlobalState
} from "../../context/GlobalState";
import {useAuth} from "../../hooks/useAuth";
import {LuPanelBottom, LuPanelRight} from "react-icons/lu";
import {LiaFileInvoiceDollarSolid} from "react-icons/lia";
import {GrVmMaintenance} from "react-icons/gr";

const NavBar = () => {
    const navigate = useNavigate();
    const {theme, layout, profile, loading} = useGlobalState();
    const {logout } = useAuth();
    const dispatch = useGlobalDispatch();

    const switchTheme = () => {
        dispatch(setTheme(theme === 'dark' ? 'light' : 'dark'));
    };
    return (
        <div className={styles["nav-container"]}>
            <div className={styles["command-icons"]}>
                <div
                    onClick={()=>navigate('/home')}
                    className={`${styles["logo"]} ${profile?.dev_mode?styles["-dev-mode"]:(profile?.is_super? styles["-super"]: '')} ${loading? styles["-rotate"]: ''} `}>
                    <img
                        src="/android-chrome-512x512.png"
                        alt="App Logo"
                        className={styles["app-logo"]}
                    />
                </div>
                <Link to="/invoice" className={"fa-icon"}
                      title={"invoice"}>
                    <LiaFileInvoiceDollarSolid />
                </Link>
                <Link to="/maintenance" className={"fa-icon"}
                      title={"maintenance"}>
                    <GrVmMaintenance  />
                </Link>
                <div className={"fa-icon -smaller"}
                     onClick={switchTheme}
                >
                    {theme === "dark" ? <FaSun title="Light mode"/> : <FaMoon title="Dark mode"/>}
                </div>
                <div className={"fa-icon"} title={"logout"}
                     onClick={() => {
                         logout();
                     }}
                >
                    <IoLogOutSharp/>
                </div>
            </div>
            <div className={styles["panel-bottom"]}>
                {profile?.account_name}
            </div>
        </div>
    )
}

export default NavBar;
